import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import { useIsEditorSpace } from '@/features/signup/platform-context';

const DashboardPage = lazy(() => import('@/features/dashboard/DashboardPage'));

/** Page d'accueil : tableau de bord d'une clinique, ou liste des cliniques dans l'espace Éditeur. */
export default function HomeRoute() {
  return useIsEditorSpace() ? <Navigate to="/editeur" replace /> : <DashboardPage />;
}
